<template>
  <jin-dialog v-model="visible" custom-class="vip-dialog" size="mini">
    <div slot="title" class="vip-dialog__h">
      <img src="../../../assets/img/vip-dialog-icon.png" alt="">
    </div>
    <div class="vip-dialog__b">
      <h3>{{dialogTitle}}~</h3>
      <p>{{textContent}}</p>
    </div>
    <div class="vip-dialog__f">
      <button class="vip-dialog__button plain" @click="close">我知道了</button>
      <button class="vip-dialog__button" @click="onVipClick">{{ submitBtnText }}</button>
    </div>
    <a
      href="https://www.jin10.com/vip_payment/index.html#/"
      class="upgrade-vip-tips" v-if="pageType === 'tradingNew' || liveType === 'tradingNew'"
      @click="onLinkClick"
    >
      {{footerText}} >>
    </a>
  </jin-dialog>
</template>

<script>
import { jin10Behavior } from '@/commons/utils'
import { mapGetters, mapState } from 'vuex'

const TRADING_NEW_TITLE = '同声传译仅限会员观看哦'
const TRADING_NEW_CONTENT = '请升级精英/VIP会员解锁直播>>'

const TRADING_NEW_OCT_TITLE = '同声传译直播仅限VIP/精英会员观看'
const TRADING_NEW_OCT_CONTENT = '限时5折成为精英，即可观看>>'

// const OCT_ACTIVITY_START_TIME = new Date('2022/10/12 00:00:00').getTime()
const OCT_ACTIVITY_START_TIME = new Date('2022/10/14 00:00:00').getTime()
const OCT_ACTIVITY_EXPIRE_TIME = new Date('2022/10/24 00:00:00').getTime()

export default {
  name: '',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['pageType', 'isVip', 'isEliteVip', 'localTime']),
    ...mapGetters([
      'isLogin',
      'liveType',
      'options'
    ]),
    isOctActivity () {
      return this.localTime >= OCT_ACTIVITY_START_TIME &&
      this.localTime < OCT_ACTIVITY_EXPIRE_TIME && this.pageType === 'tradingNew'
    },
    tradingNewTitle () {
      return this.isOctActivity
        ? TRADING_NEW_OCT_TITLE
        : TRADING_NEW_TITLE
    },
    tradingNewContent () {
      return this.isOctActivity
        ? TRADING_NEW_OCT_CONTENT
        : TRADING_NEW_CONTENT
    },

    dialogTitle () {
      return {
        tradingNew: this.tradingNewTitle,
        vip: this.options.onlySvip && !this.isEliteVip
        ? '直播仅限钻石VIP观看哦'
        : '直播仅限精英/钻石VIP观看哦'
      }[this.pageType] || this.tradingNewTitle
    },
    textContent () {
      return {
        tradingNew: this.tradingNewContent,
        vip: this.options.onlySvip && !this.isEliteVip
        ? '成为金十数据钻石VIP，即可观看直播，仅需10元/天'
        : '开通精英/钻石VIP，即可观看，仅需1元/天'
      }[this.pageType] || this.tradingNewContent
    },
    footerText () {
      return this.isOctActivity
        ? '仅15元开通会员'
        : '点我升级会员'
    },

    isVipButNotSvip () {
      return this.pageType === 'vip' && this.isVip && !this.isEliteVip
    },

    submitBtnText () {
      return this.isLogin
        ? this.isVipButNotSvip
          ? '升级VIP'
          : '成为VIP'
        : '登录'
    },
    columnName () {
      return {
        tradingNew: '同声传译',
        vip: 'vip直播'
      }[this.pageType]
    }
  },
  data () {
    return {
      visible: this.value
    }
  },
  watch: {
    value (v) {
      this.visible = v
    },
    visible (v) {
      this.$emit('input', v)
    }
  },
  created () {
  },
  methods: {
    close () {
      this.postDialogEvent('我知道了')
      this.visible = false
    },
    onVipClick () {
      const jsBridge = this.jsBridge
      const isApp = jsBridge.isApp
      if (this.pageType === 'vip') {
        jin10Behavior({
          pageName: 'VIP直播页',
          module: '成为vip弹窗',
          action: '点击',
          type: '按钮',
          object: '成为vip',
          params: {
            title: document.title
          }
        })
      }

      this.postDialogEvent(this.submitBtnText)

      const url = 'https://www.jin10.com/vip/payment/index.html'
      if (this.pageType === 'tradingNew') {
        this.$pushCnzzEvent({ event: '同传直播成为VIP' })
      }

      if (this.isLogin) {
        if (isApp) {
          jsBridge.dispatch('openAppWebViewWithNav', { url })
        } else {
          window.open(url, '_blank')
        }
        return false
      }
      if (isApp) {
        jsBridge.login()
      } else {
        this.$store.dispatch('showLogin')
        this.close()
      }
    },
    onLinkClick () {
      this.$pushCnzzEvent({ event: '同传直播升级会员' })
      this.postDialogEvent(this.footerText)
    },
    postDialogEvent (btnText) {
      jin10Behavior({
        pageName: 'tv直播页',
        module: `${this.columnName}|升级提示弹窗`,
        action: '点击',
        type: '按钮',
        object: btnText,
        params: {
          live_name: document.title,
          btn_text: btnText
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .vip-dialog{
    width: 290px;
    border-radius: 9px!important;
    top: 30%!important;
    /* transform: translate(-50%, -50%); */
    /* margin-top: -90px; */
    margin-bottom: 0!important;
    .jin10-dialog{
      &__header{
        position: relative;
        padding: 0;
        border-bottom: none;
      }
      &__headerbtn{
        width: 28px;
        height: 28px;
        border: 1px solid #fff;
        border-radius: 50%;
        top: 20px;
        right: 0;
        &:hover{
          border-color: #575f72;
          i{
            color: #575f72;
          }
        }
      }
      &__body{
        padding-left: 28px;
        padding-right: 28px;
      }
      &__close{
        position: absolute;
        top: 50%;
        left: 50%;
        padding: 7px;
        transform: translate(-50%, -50%);
        font-size: 14px;
      }
    }
    &__h{
      margin-top: -90px;
      text-align: center;
      img{
        width: 127px;
      }
    }
    &__b{
      margin-bottom: 18px;
      color: #333;
      text-align: center;
      h3{
        font-size: 16px;
        font-weight: 700;
      }
      p{
        font-size: 15px;
      }
    }
    &__f{
      font-size: 0;
      text-align: center;
      button{
        outline: none;
      }
    }
    &__button{
      display: inline-block;
      vertical-align: middle;
      width: 90px;
      height: 36px;
      line-height: 36px;
      border: 1px solid #CFAB7C;
      border-radius: 36px;
      font-size: 14px;
      color: #21232A;
      text-align: center;
      background-color: #c7a270;
      &:hover{
        background-color: #efc388;
        border-color: #efc388;
      }
      &:first-child{
        margin-right: 18px;
      }
      &.plain{
        background-color: transparent;
        color: #C59F6D;
        &:hover{
          border-color: #C59F6D;
          color: #21232A;
          background-color: #C59F6D;
        }
      }
    }
    .upgrade-vip-tips {
      margin-top: 10px;
      display: block;
      font-size: 12px;
      color: #666;
      text-align: center;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  // .dark{
  //   .vip-dialog{
  //     &__b{
  //       color: #AAAFC8;
  //     }
  //   }
  // }
</style>



// WEBPACK FOOTER //
// VipDialog.vue?b8f21a40